import { TrustBadges } from './TrustBadges';

// Right-rail card shown alongside every step form: a live summary of what
// the user has selected so far, plus trust signals near the point of commitment.
export function AdvertiseSideSummary({ title = 'Your request', items = [], footnote, children }) {
  const filled = items.filter((i) => i.value);
  return (
    <aside className="rounded-2xl border border-slate-200 bg-slate-50 p-5 lg:sticky lg:top-24">
      <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
      {filled.length > 0 ? (
        <dl className="mt-3 space-y-2.5 text-sm">
          {filled.map((i) => (
            <div key={i.label} className="flex items-start justify-between gap-3">
              <dt className="text-slate-500">{i.label}</dt>
              <dd className="text-right font-medium text-slate-900">{i.value}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p className="mt-3 text-sm text-slate-500">Your selections will appear here as you go.</p>
      )}
      {children}
      {footnote && <p className="mt-4 text-xs text-slate-500">{footnote}</p>}
      <div className="mt-5 border-t border-slate-200 pt-4">
        <TrustBadges />
      </div>
    </aside>
  );
}
